import * as constants from './constants';
import controller from './controller';

const dispatchFail = (dispatch, failType, error) => {
  return dispatch({ type: failType, payload: { error } });
};

export function resetError() {
  return dispatch => dispatch({
    type: constants.RESET_ERROR,
    payload: { error: undefined },
  });
}

export function getInsuranceCompanies() {
  return dispatch => controller.getInsuranceCompanies().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_INSURANCE_COMPANIES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_INSURANCE_COMPANIES_SUCCESS,
      payload: { insuranceCompanies: response.data, error: undefined },
    });
  });
}

export function getInsuranceCompany(id) {
  return dispatch => controller.getInsuranceCompany(id).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_INSURANCE_COMPANY_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_INSURANCE_COMPANY_SUCCESS,
      payload: { insuranceCompany: response.data, error: undefined },
    });
  });
}

export function getDeletedCompanies() {
  return dispatch => controller.getDeletedCompanies().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_CONFIRMATION_DELETED_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_CONFIRMATION_DELETED_SUCCESS,
      payload: { deletedConfirmation: response.data, error: undefined },
    });
  });
}

export function setDeletedCompanyRow(a = []) {
  return dispatch => dispatch({
    type: constants.SET_CONFIRMATION_DELETED_ROW,
    payload: { deletedConfirmation: a, error: undefined },
  });
}

export function getNewCompanies() {
  return dispatch => controller.getNewCompanies().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_CONFIRMATION_NEW_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_CONFIRMATION_NEW_SUCCESS,
      payload: { newConfirmation: response.data, error: undefined },
    });
  });
}
export function getChangedCompanies() {
  return dispatch => controller.getChangedCompanies().then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_CONFIRMATION_CHANGED_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_CONFIRMATION_CHANGED_SUCCESS,
      payload: { changedConfirmation: response.data, error: undefined },
    });
  });
}

export function copyToInsuranceList(idsForRemoval) {
  return dispatch => controller.copyToInsuranceList(idsForRemoval).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.COPY_CONFIRMATION_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.COPY_CONFIRMATION_SUCCESS,
      payload: {
        newConfirmation: [],
        changedConfirmation: [],
        deletedConfirmation: [],
        error: undefined,
      },
    });
  });
}

export function getVehicleInsurancePolicies(data) {
  // очистим список полисов авто, если не указан идентификатор авто
  if (!data?.vehicleId) {
    return dispatch => Promise.resolve().then(() => dispatch({
      type: constants.FETCH_VEHICLE_INSURANCE_POLICIES_SUCCESS,
      payload: { vehicleInsurancePolicies: [], error: undefined },
    }));
  }

  return dispatch => controller.getVehicleInsurancePolicies(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_VEHICLE_INSURANCE_POLICIES_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_VEHICLE_INSURANCE_POLICIES_SUCCESS,
      payload: { vehicleInsurancePolicies: response.data, error: undefined },
    });
  });
}

export function createVehicleInsurancePolicy(data) {
  return dispatch => controller.createVehicleInsurancePolicy(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_VEHICLE_INSURANCE_POLICY_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.CREATE_VEHICLE_INSURANCE_POLICY_SUCCESS,
      payload: { createdPolicies: response.data, error: undefined },
    });
  });
}

export function updateVehicleInsurancePolicy(data) {
  return dispatch => controller.updateVehicleInsurancePolicy(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_VEHICLE_INSURANCE_POLICY_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_VEHICLE_INSURANCE_POLICY_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function deleteVehicleInsurancePolicy(data) {
  return dispatch => controller.deleteVehicleInsurancePolicy(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_VEHICLE_INSURANCE_POLICY_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_VEHICLE_INSURANCE_POLICY_SUCCESS,
      payload: { error: undefined },
    });
  });
}
